module.exports = __webpack_public_path__ + "static/media/image_3.5d2349ef.png";